/**
 * MobileNav Component - Bottom navigation for mobile
 */

import React from 'react'
import {
  LayoutDashboard,
  Wallet,
  ShieldCheck,
  Crown,
  User,
  Compass,
  MessageSquare,
  Settings,
  Building2,
  FileCheck,
  Handshake,
  DollarSign,
  Users,
  Upload,
  ClipboardList,
  Briefcase,
} from 'lucide-react'

const iconMap = {
  LayoutDashboard,
  Wallet,
  ShieldCheck,
  Crown,
  User,
  Compass,
  MessageSquare,
  Settings,
  Building2,
  FileCheck,
  Handshake,
  DollarSign,
  Users,
  Upload,
  ClipboardList,
  Briefcase,
}

const MobileNav = ({
  items = [],
  activeTab,
  onSelect,
  className = '',
  ...props
}) => {
  // Only show top-level items (no children)
  const navItems = items
    .filter(item => !item.children)
    .slice(0, 5) // Max 5 items

  if (navItems.length === 0) return null

  return (
    <nav
      className={`
        md:hidden fixed bottom-0 left-0 right-0
        bg-surface border-t border-neutral-200
        flex items-center justify-around
        px-2 py-1.5
        z-40
        ${className}
      `}
      {...props}
    >
      {navItems.map((item) => {
        const Icon = iconMap[item.icon] || LayoutDashboard
        const isActive = activeTab === item.route

        return (
          <button
            key={item.id}
            onClick={() => onSelect?.(item.route)}
            className={`
              flex flex-col items-center gap-0.5
              px-3 py-1.5
              min-w-[48px] min-h-[44px]
              rounded-lg
              transition-colors
              ${isActive 
                ? 'text-brand' 
                : 'text-neutral-400 hover:text-ink'
              }
            `}
            aria-current={isActive ? 'page' : undefined}
          >
            <Icon size={20} className={isActive ? 'text-brand' : ''} />
            <span className="text-[10px] font-medium leading-none">
              {item.label}
            </span>
          </button>
        )
      })}
    </nav>
  )
}

MobileNav.displayName = 'MobileNav'

export default MobileNav